import { $, $$ } from '@3pc/dom';
import Slider from 'modules/glide/glide';

const gridSliders = $$('.teaser-slide');

if (gridSliders.length) {
  gridSliders.forEach(gridSlider => {
    const slidesLength = $$('.teaser-slide__item', gridSlider).length;
    if (slidesLength === 1) return;

    const slider = new Slider($('.glide', gridSlider), {
      config: {
        type: 'carousel',
        startAt: 0,
        perView: 3,
        controls: $('.glide__inner', gridSlider),
        bullets: true,
        gap: 20,
        breakpoints: {
          1199: {
            perView: 2,
          },
          767: {
            perView: 1,
          },
        },
      },
    });
    slider.init();
  });
}
